/* eslint-disable @next/next/no-img-element */
import React from 'react'
import PaymentMethodDetails from './PaymentMethodDetails'
import PlatformPayDetails, { getWalletDisplay } from './PlatformPayDetails'
import ArrowUp from '../../../public/images/arrow-up-red.svg'
import ArrowDown from '../../../public/images/arrow-down-red.svg'
import Image from 'next/image'
import { Text } from '../../styles/Components'
import { PLATFORM_PAY } from '../../helpers'

// Check badge shown at the right edge of the currently selected row in the open
// menu (QA: selected rows use a sand background with a cobalt check instead of the
// old solid-cobalt fill, whose text was illegible). Purely decorative, so it's
// hidden from assistive tech — selection state is exposed instead via
// aria-pressed on each row's button.
const SelectedCheck = () => (
  <img
    className="selected-check"
    src="/images/checkmark-circle-cobalt.svg"
    alt=""
    aria-hidden="true"
  />
)

const ChoosePaymentDropdown = ({
  isPaymentMethodMenuVisible,
  toggleIsPaymentMethodMenuVisible,
  selectedPaymentMethod,
  selectedPaymentMethodId,
  paymentMethods,
  togglePaymentSelected,
  toggleShowAddPaymentMethod,
  error,
  platformPayAvailability,
}) => {
  // The wallet mark + label (or null until the ECE reports a wallet, which hides the row).
  const wallet = getWalletDisplay(platformPayAvailability)
  const walletLabel = wallet?.label ?? null
  const walletMark = wallet?.mark ?? null
  const isPlatformPaySelected = selectedPaymentMethodId === PLATFORM_PAY
  return (
    <>
      <div
        className={`payment-method-select ${isPaymentMethodMenuVisible ? 'open' : ''}`}
      >
        <button
          className="payment-method-summary"
          onClick={toggleIsPaymentMethodMenuVisible}
        >
          {selectedPaymentMethod && (
            <PaymentMethodDetails method={selectedPaymentMethod} />
          )}
          {isPlatformPaySelected && walletLabel && (
            <PlatformPayDetails label={walletLabel} mark={walletMark} />
          )}
          {isPaymentMethodMenuVisible ? (
            <Image src={ArrowUp} alt="" aria-hidden="true" />
          ) : (
            <Image src={ArrowDown} alt="" aria-hidden="true" />
          )}
        </button>
        <div className="menu">
          <ul
            data-testid="saved-payment-methods"
            className="saved-payment-methods"
          >
            {/* Platform pay sits at the top of the list, above saved cards. */}
            {walletLabel && (
              <li className={isPlatformPaySelected ? 'selected' : ''}>
                <button
                  className="card-select"
                  data-testid="platform-pay-select"
                  aria-pressed={isPlatformPaySelected}
                  onClick={() => togglePaymentSelected(PLATFORM_PAY)}
                >
                  <PlatformPayDetails label={walletLabel} mark={walletMark} />
                  {isPlatformPaySelected && <SelectedCheck />}
                </button>
              </li>
            )}
            {paymentMethods &&
              paymentMethods.map((paymentMethod, i) => (
                <li
                  className={
                    paymentMethod.id === selectedPaymentMethodId
                      ? 'selected'
                      : ''
                  }
                  key={i}
                >
                  <button
                    className="card-select"
                    aria-pressed={paymentMethod.id === selectedPaymentMethodId}
                    onClick={() => togglePaymentSelected(paymentMethod.id)}
                  >
                    <PaymentMethodDetails method={paymentMethod} />
                    {paymentMethod.id === selectedPaymentMethodId && (
                      <SelectedCheck />
                    )}
                  </button>
                </li>
              ))}
            <li className='add-payment-li'>
              <button
                className="add-payment-method"
                data-testid="new-payment-btn"
                id="new-payment-btn"
                type="button"
                onClick={() => {
                  toggleShowAddPaymentMethod()
                  toggleIsPaymentMethodMenuVisible()
                }}
              >
                + New Payment Method
              </button>
            </li>
          </ul>
        </div>
      </div>
      {error && (
        <p className="payment-error" role="alert">
          {error}
        </p>
      )}
      <div className="protection">
        <img src="/images/powered_by_stripe.svg" alt="Powered by Stripe" />
        <Text fontSize={12}>Your personal information is protected.</Text>
      </div>
    </>
  )
}

export default ChoosePaymentDropdown
